import { Flex, type FlexProps } from '@/ui';
import type { OrgMember } from '../hooks/useOrganizationMembers';
import { MemberRow } from './MemberRow';

type Props = FlexProps & {
  members: OrgMember[];
  organizationName: string;
  isRemoving?: boolean;
  onRemove: (userId: string, options?: { onSuccess?: () => void }) => void;
  smsContactsEnabled?: boolean;
  onEditContact?: (member: OrgMember) => void;
};

export const MembersList = ({
  members,
  organizationName,
  isRemoving,
  onRemove,
  smsContactsEnabled,
  onEditContact,
  ...props
}: Props) => {
  return (
    <Flex
      direction="column"
      gap="3"
      maxH={{ base: '100%', md: '368px' }}
      ml="-4"
      overflowX="hidden"
      overflowY="auto"
      px="4"
      w="calc(100% + 28px)"
      {...props}
    >
      {members.map((member) => (
        <MemberRow
          data-testid="org-member-row"
          isRemoving={isRemoving}
          key={member.user.id}
          member={member}
          organizationName={organizationName}
          smsContactsEnabled={smsContactsEnabled}
          onEditContact={onEditContact}
          onRemove={onRemove}
        />
      ))}
    </Flex>
  );
};
